import { render, staticRenderFns } from "./CheckboxClusterWithAddText.vue?vue&type=template&id=05bd9ed6&scoped=true&"
import script from "./CheckboxClusterWithAddText.vue?vue&type=script&lang=js&"
export * from "./CheckboxClusterWithAddText.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxClusterWithAddText.vue?vue&type=style&index=0&id=05bd9ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd9ed6",
  null
  
)

export default component.exports